import { render, staticRenderFns } from "./EnableTelegramAlertsComponent.vue?vue&type=template&id=fb393882&scoped=true&"
import script from "./EnableTelegramAlertsComponent.vue?vue&type=script&lang=ts&"
export * from "./EnableTelegramAlertsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./EnableTelegramAlertsComponent.vue?vue&type=style&index=0&id=fb393882&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb393882",
  null
  
)

export default component.exports